<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Payment Date"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="brand">
                Payment Date <span class="required-color">*</span></label
              >
              <input
                type="date"
                id="brand"
                class="form-control"
                v-model="paymentDate"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid date"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Payment Date"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-12">
                <ValidationProvider name="category" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Payment Head</label>
                  <select
                    class="form-control"
                    v-model="category"
                    name="category_id"
                    style="width: 100%;"
                  >
                    <option id="category" selected value=""
                      >Choose Payment Head</option
                    >
                    <option
                      v-for="item in categoryList"
                      :key="item.category_id"
                      v-bind:value="item.category_id"
                      >{{ item.category_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-6">
             <ValidationProvider
               name="Reference No"
                  rules="alpha"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="bill-no">
                Reference Number</label
              >
              <input
                type="text"
                class="form-control"
                id="bill-no"
                v-model="referenceNumber"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid reference number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Reference Number"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <div class="col-sm-6">
             <ValidationProvider
               name="Paid Amount"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="amount">
              Paid Amount <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="amount"
                class="form-control"
                v-model="amount"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid amount"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Amount"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>

          <div class="col-md-12">
             <ValidationProvider
               name="Descriptoin"
                  rules="alpha"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="description">
              Description</label
              >
              <input
                type="text"
                id="description"
                class="form-control"
                v-model="description"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid description"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Description"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <div class="modal-footer" style="text-align: right">
           <div class="col-sm-12">
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["paymentId"],
  name: "AddPayment",
  data() {
    return {
      response: null,
      saveCat: false,
      itemId: '',
      paymentDate: '',
      referenceNumber: '',
      amount: '',
      category: '',
      categoryList: [],
      description: '',
      errors : [],
      loading: false,
    };
  },
  components: {
  },
  computed: {
  },
  methods: {
    getCategories: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_payment_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.paymentId;
      this.errors = []
      if (!this.paymentDate) {
        this.errors.push("Payment Date is required.");
      }
      if (!this.amount) {
        this.errors.push("Amount is required.");
      }
      if (!this.category) {
        this.errors.push("Payment Head is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "payment-form": {
          payment_id: this.itemId,
          payment_date: this.paymentDate,
          reference_no: this.referenceNumber,
          amount: this.amount,
          category_id: this.category,
          description: this.description
        },
      };
      if (this.itemId > 0) {
        console.log('add_item', addItem)
        api
          .request("post", "GeneralApis/edit_payment", addItem)
          .then((response) => {
            console.log(response)
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        console.log('add_item', addItem)
        api
          .request("post", "GeneralApis/add_payment", addItem)
          .then((response) => {
            var data = response.data;
            console.log('')
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getPayment: function() {
      var payment_id = this.$props.paymentId;
        (this.paymentDate = ""),
        (this.amount = ""),
        (this.description = ""),
        (this.referenceNumber = ""),
        (this.itemId = 0);
      if (payment_id > 0) {
        this.itemId = payment_id;

        const getItem = {
          filter: {
            payment_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_payment", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const paymentList = data.paymentList[0];
              this.paymentDate = paymentList.payment_date;
              this.referenceNumber = paymentList.reference_no;
              this.amount = paymentList.amount;
              this.description = paymentList.description;
              this.category = paymentList.category_id
            }
          });
      }
    },
  },
  mounted() {
    this.getPayment();
    this.getCategories();
  },
};
</script>

<style scoped>
.qty-cell{
  width: 50px;
}
</style>